import React,{useState,useEffect} from 'react'
import DisplayData from './DisplayResult';
import axios from 'axios';
import reset from '../../assets/certificate/reset.png';
import './Certificate_Verify.css'
import CandidateHeader from "../Candidate/Candidate Navbar/Header";
import Footer from './Footer';
import Backgorund from '../../assets/certificate/background.jpg'
import certificateIcon from '../../assets/certificate/graduation.png'
import { toast } from 'react-toastify';

function Validator(){

    const [click,setClick] = useState(true);
    const [input,setInput]= useState({
        certificate_number:''
    });
    const [result,setResult]= useState(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState({opacity:0.3});
    
  
    const BASE_URL="https://certificate.aspireitacademy.com";

    const inputHandler = (e)=>{
        setInput ({...input,[e.target.name]:e.target.value})
        
    }

    const verification = () =>{    
        if(input.certificate_number.length >= 7 ){
                return axios.post(BASE_URL+"/certificate_validation",input).then((res)=>{
                    setResult(res.data);         
            }).catch((error) => {
                toast.error("Something Went Wrong", {toastId: 'err1',});

            })
        }
       
        
              
    }
    
    useEffect(() => {
            
        if (input.certificate_number.length < 7 ) {
            setIsButtonDisabled({opacity:0.3});
        }
        else {
            setIsButtonDisabled({opacity:1});
        }
     }, [input]);
     
  
  

    return(
<section style={{   backgroundImage: `url(${Backgorund})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                minHeight: "100vh"}}>
<CandidateHeader />   
<div className='validator-Container d-flex justify-content-center m-3 p-3'
                onClick={()=> setClick(!click)}
                >
    <div className='verifyData'>
       
         <h3 className='text-center verify-header mb-4'>
         <img src={certificateIcon} className='me-1' alt="Certificate-icon" width="28px" height="24px"/>
   
            Validate your Certificate
              </h3>
         <div className='verifier-inputContainer d-flex justify-content-center align-items-center my-4'
         >
            <input type="text" 
                     className="form-control me-2 " 
                     name="certificate_number" 
                     placeholder='Enter Certificate No.' 
                     onChange={inputHandler}/>
            <button className='validatorBtn btn btn-primary me-2' 
                    style={isButtonDisabled} 
                    onClick={()=>{verification()}}>Validate</button>

            {result && ( <a onClick={()=>{window.location.reload(true)}}><img 
            className="resetImg" 
            width="23px" height="23px"style={{cursor:'pointer'}}
            src={reset}/></a>)}

        </div>
        {   result ? <DisplayData  output={result}  baseurl={BASE_URL}   certfcno={input.certificate_number} 
                           bodyClick={click} /> : ''
        } 
    </div>
</div>
<Footer /> 
</section>
    )

}
export default Validator;